import styled from 'styled-components/macro';
import ArbitrationHeader from './components/ArbitrationHeader';
import ArbitrationMatches from './components/ArbitrationMatches';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: ${({ theme }) => theme.white};
  min-height: 100%;
`;
export const ArbitrationHeaderStyled = styled(ArbitrationHeader)`
  height: 161px;
`;

export const ArbitrationMatchesStyled = styled(ArbitrationMatches)``;
